import type { AdminRole } from '@/lib/auth-store';

export type AdminAccount = {
  id: string;
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  role: AdminRole;
  is_active: boolean;
  created_at: string;
  last_login_at: string | null;
};

export type AdminAccountListResponse = { items: AdminAccount[]; total: number };

export type CreateAdminInput = {
  email: string;
  password: string;
  first_name: string;
  last_name?: string;
  role: AdminRole;
};

export const ADMIN_ROLE_OPTIONS: { value: AdminRole; label: string; hint: string }[] = [
  { value: 'ADMIN', label: 'Admin', hint: 'Full console access' },
  { value: 'SUPER_ADMIN', label: 'Super admin', hint: 'Full access, plus managing admin accounts' },
];
